import config from "react-global-configuration"
import * as moment from "moment"
import "moment/locale/da"
import "moment/locale/en-gb"

export const momentLocale = (locale) => {
  locale = locale || config.get("locale") || "da"
  if (locale === "en") return "en-gb"
  if (locale === "se") return "en-gb"
  return locale
}

export const luxonLocale = (locale) => {
  locale = locale || config.get("locale") || "da"
  if (locale === "en") return "en-GB"
  if (locale === "se") return "en-GB"
  return locale
}

export const formatDate = (date, format, locale) => {
  const formatted = moment(date).locale(momentLocale(locale)).format(format)
  return formatted
}

// handle format change, but also handle dates that are already formatted in target format
export const formatDateWithPrevFormat = (date, prevFormat, currentFormat) => {
  const momentDate = moment(date, prevFormat, true)
  if (momentDate.isValid()) {
    return momentDate.format(currentFormat)
  } else {
    const formatted = moment(date).format(currentFormat)
    return formatted
  }
}

export const getDateFromFormat = (date, format) => {
  return moment(date, format)._d
}

export const getLocaleDateFromFormat = (date, format, locale) => {
  return moment(date, format).locale(momentLocale(locale))._d
}

export const AddDays = (date, days) => {
  return moment(date).add(days, "d")._d
}

export const SubtractDays = (date, days) => {
  return moment(date).subtract(days, "d")._d
}

export const AddHours = (date, hours) => {
  return moment(date).add(hours, "h")._d
}

export const SubtractHours = (date, hours) => {
  return moment(date).subtract(hours, "h")._d
}

export const AddMinutes = (date, mins) => {
  return moment(date).add(mins, "minutes")._d
}

export const SubtractMinutes = (date, mins) => {
  return moment(date).subtract(mins, "minutes")._d
}

export const SetTime = (date, key, value) => {
  return moment(date).set(key, value)._d
}

export const RoundToNearestMinutes = (date, minutes) => {
  const start = moment(date)
  const remainder = minutes - (start.minute() % minutes)
  return moment(start).add(remainder, "minutes")._d
}

export const RoundToNearestMinutesLuxon = (date, minutes) => {
  const start = date
  const remainder = minutes - (start.minute % minutes)
  return start.plus({ minutes: remainder })
}

export const RoundDownToNearestMinutesLuxon = (date, minutes) => {
  const start = date
  const remainder = start.minute % minutes
  return start.minus({ minutes: remainder })
}

export const IsSame = (d1, d2) => {
  const date1 = moment(d1)
  const date2 = moment(d2)
  return date1.isSame(date2, "date")
}

export const GetMomentDate = (date) => {
  return moment(date)._d
}

export const IsDaylightSavingsChangeDay = (d) => {
  const date = moment(d, "DD/MM/YYYY")
  const month = date.format("M")
  if (month === 3) {
    const lastSunday = LastSundayOfMonth(d)
    if (IsSame(date, lastSunday)) {
      return true
    }
  }
  return false
}

export const LastSundayOfMonth = (d) => {
  const fm = moment(d, "DD/MM/YYYY").add(1, "M")
  const fmEnd = moment(fm).endOf("month")
  const date = moment(d, "DD/MM/YYYY").date() !== fm.date() && fm.isSame(fmEnd.format("DD/MM/YYYY")) ? fm.add(1, "d") : fm
  const lastDayOfMonth = date.date(0)
  let lastSunday
  for (let i = 1; i < 8; i++) {
    const tempDay = moment(lastDayOfMonth).subtract(i, "days")
    if (tempDay.day() === 0) {
      lastSunday = tempDay
      break
    }
  }
  return lastSunday
}

export const DateDiff = {
  inDays: function (d1, d2) {
    var t2 = d2.getTime()
    var t1 = d1.getTime()

    return parseInt((t2 - t1) / (24 * 3600 * 1000))
  },

  inWeeks: function (d1, d2) {
    var t2 = d2.getTime()
    var t1 = d1.getTime()

    return parseInt((t2 - t1) / (24 * 3600 * 1000 * 7))
  },

  inMonths: function (d1, d2) {
    var d1Y = d1.getFullYear()
    var d2Y = d2.getFullYear()
    var d1M = d1.getMonth()
    var d2M = d2.getMonth()

    return d2M + 12 * d2Y - (d1M + 12 * d1Y)
  },

  inYears: function (d1, d2) {
    return d2.getFullYear() - d1.getFullYear()
  },
}
